import { useCallback } from "react";
import { useDraw } from "react-scribble";
import Simplex from "simplex-noise";
import { normalize } from "../math";
import { AnimatedValue } from "../animated-value";

const simplex = new Simplex();
const phase = new AnimatedValue(0);

export const Background = ({ color = "#fff", scroll, width, offset = 20 }) => {
  useDraw(
    useCallback(
      (ctx, canvas) => {
        ctx.beginPath();

        const body = document.body;
        const html = document.documentElement;
        const bodyHeight = Math.max(body.scrollHeight, html.scrollHeight);
        const offsetX = (window.innerWidth - width) / 2;
        const phaseValue = phase.getAnimatedValue();
        const scrollValue = scroll.getAnimatedValue();

        for (let y = 0; y < window.innerHeight; y += 1) {
          const variation = normalize(
            simplex.noise2D(
              offsetX + phaseValue,
              normalize(y + scrollValue, 0, bodyHeight, 0, 2)
            ),
            -1,
            1,
            -offset,
            offset
          );

          if (!y) {
            ctx.moveTo(offsetX + variation - offset * 3, y);
          } else {
            ctx.lineTo(offsetX + variation - offset * 3, y);
          }
        }

        for (let y = window.innerWidth; y >= 0; y -= 1) {
          const variation = normalize(
            simplex.noise2D(
              offsetX + width + phaseValue,
              normalize(y + scrollValue, 0, bodyHeight, 0, 2)
            ),
            -1,
            1,
            -30,
            30
          );

          if (!y) {
            ctx.lineTo(offsetX + width + variation + offset * 3, y);
          } else {
            ctx.lineTo(offsetX + width + variation + offset * 3, y);
          }
        }

        ctx.closePath();

        ctx.fillStyle = color;
        ctx.fill();
        phase.setValue(phaseValue + 0.001);
      },
      [color, offset, scroll, width]
    )
  );
  return null;
};
